import { authenticatedPostRequest } from '../RestApi';


// This functionality supports sending the user to Stripe's Manage Subscription portal
// by first creating a temporary session on their behalf. 
export async function createStripePortalSession(cognitoSub) {
    if (!cognitoSub) {
        console.error('No cognito sub provided');
        return;
    }

    try {
        const data = await authenticatedPostRequest(
            `${process.env.REACT_APP_SUBSCRIPTION_API_URL}/create_stripe_customer_portal_session`,
            { 
                cognitoSub: cognitoSub, 
                return_path: process.env.REACT_APP_WWW_URL + '/dashboard'
             }
        );

        if (data.portalUrl) {
            console.log("Redirecting to Stripe Portal:", data.portalUrl);
            window.location.href = data.portalUrl;
        } else {
            console.error('No portal URL received from server');
        }
    } catch (error) {
        console.error('Error creating Stripe portal session:', error);
        throw error;
    }
}


export async function createStripeCheckoutSession(cognitoSub, priceId, returnPath = process.env.REACT_APP_WWW_URL + '/dashboard') {
    if (!cognitoSub) {
        console.error('No cognito sub provided');
        return;
    }

    try {
        const data = await authenticatedPostRequest(
            `${process.env.REACT_APP_SUBSCRIPTION_API_URL}/stripe_start_checkout`,
            { 
                cognitoSub: cognitoSub, 
                return_path: returnPath,
                priceId: priceId
             }
        );

        if (data.checkoutUrl) {
            console.log("Redirecting to Stripe Checkout:", data.checkoutUrl);
            window.location.href = data.checkoutUrl;
        } else {
            console.error('No checkout URL received from server', data);
        }
    } catch (error) {
        console.error('Error creating Stripe checkout session:', error);
        throw error;
    }
}